import { NavBar } from '@/components/index'
import { Outlet, useLocation } from 'react-router-dom'
import { Toaster } from '@/components/ui/sonner'
import { useRouteHandle } from '@/hooks'
import { useAuth } from './contexts/auth.context'
import { ROUTE_SIGN_IN } from './routes/paths'
import useLoading from '@/hooks/use-loading'

function App() {
  useRouteHandle()
  const { authenticated, isTokenRefreshing } = useAuth()
  const { pathname } = useLocation()
  // Simulate a loading delay
  const loading = useLoading()

  const LoadingIndicator = () => <div>Loading...</div>

  if (loading) {
    return <LoadingIndicator />
  }
  if (isTokenRefreshing) {
    return <div>Token refreshing...</div>
  }

  return (
    <>
      {pathname !== ROUTE_SIGN_IN && authenticated ? <NavBar /> : null}
      <Toaster position="bottom-left" />
      <Outlet />
    </>
  )
}
export default App
